<template>
  <div>
    <div ref="queryBox">
      <el-row type="flex" justify="space-between" style="margin-top: 30px;margin-bottom: 30px;">
          <el-col :span="(queryParams && (queryParams.carryoverId||queryParams.departmentId))? 24:14">
            <el-form :inline="true">
              <el-form-item>
                <span slot="label" style="line-height: 34px;font-size: 20px; font-weight: bold;">{{ dealershipInfo.nameCn }}</span>
                <el-select v-model="outLetId"
                           @change="outLetChange"
                           :placeholder="$t('talentpool.selectOutlet')"
                           style="width: 260px;">
                  <el-option
                    v-for="item in dealershipInfo.outletList"
                    :key="item.orgId"
                    :label="item.nameCn"
                    :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        <el-col v-if="!(queryParams && (queryParams.carryoverId||queryParams.departmentId))" :span="24">
          <iframe
            style="margin-top: -100px;margin-left: -25px"
            allowFullScreen="true"
            width="100%"
            height="200"
            frameborder="0"
            id="iframe"
            title=""
            :src="ochartIframeUrl">
          </iframe>
        </el-col>
      </el-row>
      <el-row style="margin-top: -30px">
        <el-col :span="24" v-if="JSON.stringify(data) !== '{}'">
          <el-row :gutter="20">
            <!--<el-col :span="3" style="text-align: right; min-width: 90px;">-->
              <!--<label style="line-height: 34px;text-align: right;">下载缩放比例: </label>-->
            <!--</el-col>-->
            <!--<el-col :span="3">-->
              <!--<el-tooltip placement="bottom">-->
                <!--<div slot="content">-->
                  <!--数据格式：1～1000的正整数。-->
                  <!--<br/>-->
                  <!--说明：数字越大，图片越清晰。-->
                <!--</div>-->
                <!--<el-input v-model="scaleNum">-->
                  <!--<span slot="suffix" style="line-height: 34px;">%</span>-->
                <!--</el-input>-->
              <!--</el-tooltip>-->
            <!--</el-col>-->
            <el-col :span="16">
              <el-button type="primary" @click="isShowDownPic = true">{{$t('talentpool.exportOrgPic')}}</el-button>
              <el-button type="primary" @click="exportUserInfo()">{{$t('talentpool.exportUserInfo')}}</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--<el-scrollbar class="scrollbarSet" id="bba_html2canvas_sc">-->
    <div :style="{'height': cardHeight+'px','overflow':'scroll'}" ref="bba_print_ref">
        <div class="tree-wrapper" v-if="JSON.stringify(data) !== '{}'">
          <org-tree :data="data"
                    ref="orgRef"
                    id="org-tree-app"
                    style="padding: 50px 50px 50px 250px"
                    collapsable
                    :node-render="nodeRender"
                    :expand-all="expandAll"
                    :horizontal="false"
                    :props="props"
                    @on-expand="onExpand"
                    @on-node-click="onNodeClick"
                    @on-node-right-click="rightClickHandler"></org-tree>
        </div>
        <div v-else>{{dataLoading}}</div>
        <span ref="warterMarkContentRef" style="font-size: 50px;white-space:nowrap;visibility: hidden">{{warterMarkContent}}</span>
      </div>
    <!--</el-scrollbar>-->
    <e-vue-contextmenu v-if="!isPrint" ref="contextmenuRef"
                       style="min-width: 76px;"
                       class="right-menu">
      <a href="javascript:;" @click="updateGroupList">{{$t('talentpool.edit')}}</a>
    </e-vue-contextmenu>
    <!--分组dialog-->
    <el-dialog
      :title="$t('talentpool.editGroup')"
      :visible.sync="dialogVisible"
      width="350"
      height="400"
      top="10vh"
      :show-close="false"  append-to-body :close-on-click-modal="false">
      <label style="font-weight: bold;">{{$t('talentpool.groupName')}}</label>
      <el-input style="width: 200px;margin-bottom: 10px;" v-model="groupName">
      </el-input>
      <el-button style="text-align:right; float:right;margin-right: 100px" v-show="curRightClickId" type="primary" @click="dissolution">{{$t('talentpool.dissolve')}}</el-button>
      <el-table
        ref="groupTableRef"
        :data="groupTableData"
        height="460"
        border
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="userNameCn"
          :label="$t('talentpool.name')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="userCode"
          :label="$t('talentpool.userId')">
        </el-table-column>
        <el-table-column
          prop="positionName"
          :label="$t('talentpool.jobCode')">
        </el-table-column>
      </el-table>
      <br>
      <el-form>
        <el-row style="text-align:right; float:right;" :gutter="20">
            <el-button size="mini" type="primary" @click="dialogVisible = false">{{$t('talentpool.takeAway')}}</el-button>
            <el-button size="mini" type="primary" @click="saveGroup">{{$t('talentpool.sure')}}</el-button>
        </el-row>
      </el-form>
      <br>
      <div></div>
    </el-dialog>
    <!--下载组织架构图dialog-->
    <el-dialog :title="$t('talentpool.exportOrgPic')"  :visible.sync="isShowDownPic" top="15vh" width="50%" :close-on-press-escape = "false" :showClose="false" :close-on-click-modal="false" append-to-body>
      <el-form :inline="true" ref="downPicRef" @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :span="6" :offset="4" style="text-align: right; min-width: 90px;">
            <label style="line-height: 34px;text-align: right;">{{$t('talentpool.downloadScale')}}</label>
          </el-col>
          <el-col :span="6">
            <el-tooltip placement="bottom">
              <div slot="content">
                {{$t('talentpool.downloadInstructionsOne')}}
                <br/>
                {{$t('talentpool.downloadInstructionsTwo')}}
              </div>
              <!--<el-input v-model="scaleNum">-->
                <!--<span slot="suffix" style="line-height: 34px;">%</span>-->
              <!--</el-input>-->
              <el-slider v-model="scaleNum" :min=0 :max=500></el-slider>
            </el-tooltip>
          </el-col>
        </el-row>
        <br>
        <el-row :gutter="20">
          <el-col :span="24" style="text-align: right">
            <el-form-item style="text-align: right">
              <!--返回按钮-->
              <el-button type="primary" :loading="butLoading" @click="isShowDownPic = false">{{$t('talentpool.takeAway')}}</el-button>
              <el-button type="primary" :loading="butLoading" @click="saveImage($t('talentpool.organizationChart'))">{{$t('talentpool.export')}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/jsx">
import OrgTree from './org-tree'
// import { data } from './data'
// import Print from '@/utils/print_plug'
import Print from '../../../../utils/print_plug'
import html2canvas from 'html2canvas'

export default {
  name: 'orgtreetwo',
  props: {
    isPrint: {
      // 默认不是打印页面
      type: Boolean,
      default: false
    },
    queryParams: Object
  },
  components: {
    OrgTree
  },
  data () {
    return {
      data: {},
      expandAll: true,
      props: {
        id: 'userId',
        label: 'userNameCn',
        expand: 'expand',
        children: 'childrenUserInfoList'
      },
      dealershipInfo: {
        'bbaNo': '',
        // 品牌
        'brandNames': '',
        'dealerSize': '',
        // 经销商名称
        'nameCn': '',
        'nameEn': '',
        // 经销商类型
        'networkTypes': '',
        // NSC NO
        'nscNo': '',
        // 经销商ID
        'orgId': '',
        // outletList
        'outletList': [],
        // 城市
        'regionName': ''
      },
      outLetId: '',
      contextMenuTarget: undefined,
      contextMenuVisible: false,
      groupTableData: [],
      dialogVisible: false,
      // 小组名称
      groupName: '',
      // 右击时，小组组长的userId
      curRightClickUserId: '',
      // 右击时，组长的positionId
      positionId: '',
      // 右击时，小组id
      curRightClickId: '',
      scaleNum: 300,
      dataLoading: this.$t('talentpool.temporarilyNoData'),
      //////////////下载组织架构图dialog//////////////
      isShowDownPic: false,
      ochartIframeUrl: '',
      butLoading: false,
      // 组织架构图的高度
      cardHeight: undefined,
      //水印的内容
      warterMarkContent: ''
    }
  },
  methods: {
    //  图片转换格式的方法
    dataURLToBlob (dataurl) {
      let arr = dataurl.split(',')
      // let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      // return new Blob([u8arr], mime)
      return new Blob([u8arr], { type: 'image/png;charset=utf-8' })
    },
    /**
     * 官网地址：http://html2canvas.hertzen.com/faq/
     * Chrome:
     * 最大高度/宽度：32,767像素最大面积：268,435,456像素（例如，16,384 x 16,384）
     * Firefox:
     * 最大高度/宽度：32,767像素最大面积：472,907,7 76像素（例如，22,528 x 20,992）
     * Internet Explorer:
     * 最大高度/宽度：8,192像素最大面积：N / A.
     * iOS:
     * 对于RAM小于256 MB的设备，画布元素的最大大小为3百万像素，对于大于或等于256 MB RAM的设备，最大大小为5百万像素
     **/
    /*
      保存图片的方法（即按钮点击触发的方法）
      第一个参数为保存图片的名称
      */
    saveImage (imgText) {
      this.clearWaterMark() //清空水印
      this.butLoading = true
      if (!this.scaleNum || !this.checkScaleNum(Number(this.scaleNum))) {
        this.butLoading = false
        this.$message.warning('请输入1～1000的正整数！')
        return false
      }
      // 获取水印的宽度
      let waterMarkWidth = this.$refs.warterMarkContentRef.offsetWidth
      // 根据宽度计算高度
      let waterMarkHeight = waterMarkWidth*0.70710678118655
      // 添加水印内容
      this.$refs.orgRef.setWarterMark(this.warterMarkContent,waterMarkHeight)

      console.log('scale==>', this.scaleNum)
      // 滚动条置顶，防止图片导出不全
      window.scrollTo(0, 0)
      // document.querySelector('#bba_html2canvas_sc > .el-scrollbar__wrap').scrollLeft = 0
      //  缩放比例
      let scale = this.scaleNum / 100
      let canvasID = document.querySelector('#org-tree-app')
      let width = canvasID.offsetWidth + 100
      let height = canvasID.offsetHeight
      console.log('width, height==>', width, height)

      // let canvas = document.createElement('canvas')
      // canvas.width = width * scale
      // canvas.height = height * scale
      // canvas.getContext('2d').scale(scale, scale)
      console.log('computed area, width, height', (width * scale) * (height * scale), width * scale, height * scale)
      if (!this.checkWidthAndHeight(width, height, scale)) {
        this.clearWaterMark() //清空水印
        this.butLoading = false
        return false
      }
      let proportionNum = scale
      if(this.scaleNum > 150){
        proportionNum = (this.scaleNum - 150) / 100
      }
      let opts = {
        scale: proportionNum,
        logging: true,
        // canvas: canvas,
        width: width,
        height: height
      }
      let that = this
      let a = document.createElement('a')
      html2canvas(canvasID, opts).then(canvas => {
        let dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        a.style.display = 'none'
        document.body.removeChild(dom)
        let blob = that.dataURLToBlob(dom.toDataURL('image/png'))
        // for IE(zzie)
        if ('msSaveOrOpenBlob' in navigator || (window.navigator && window.navigator.msSaveOrOpenBlob)) {
          window.navigator.msSaveOrOpenBlob(blob, imgText + '.png')
          // 关闭下载组织架构图dialog
          this.clearWaterMark() //清空水印
          this.isShowDownPic = false
          this.butLoading = false
        } else {
          // for Non-IE (chrome, firefox etc.)
          a.setAttribute('href', URL.createObjectURL(blob))
          // 这块是保存图片操作  可以设置保存的图片的信息
          a.setAttribute('download', imgText + '.png')
          document.body.appendChild(a)
          a.click()
          URL.revokeObjectURL(blob)
          document.body.removeChild(a)
          // 关闭下载组织架构图dialog
          this.clearWaterMark() //清空水印
          this.isShowDownPic = false
          this.butLoading = false
        }
      })

    },
    // 清空水印的方法
    clearWaterMark () {
      let id = '1.23452384164.123412999'
      if (document.getElementById(id) !== null) {
        document.getElementById('org_tree_imgs').childNodes[0].removeChild(document.getElementById(id))
      }
    },

    // 判断输入的缩放比例的格式是否正确
    checkScaleNum (val) {
      // 1～1000的正整数
      return (typeof val === 'number' && /^[1-9]\d*$/.test(val) && val >= 1 && val <= 1000)
    },
    // 判断浏览器类型
    checkWidthAndHeight (width, height, scale) {
      let agent = navigator.userAgent.toLowerCase()
      console.log(agent)
      // google
      let googleMaxPixels = 268435456
      let googleMaxHorW = 32767

      // firefox
      let firefoxMaxPixels = 472907776
      let firefoxMaxHorW = 32767

      // Internet Explorer
      // let ieMaxPixels = 'N/A'
      let ieMaxHorW = 8192

      if (agent.indexOf('chrome') > 0) {
        // alert("chrome浏览器")
        if ((width * scale) * (height * scale) > googleMaxPixels || width * scale > googleMaxHorW || height * scale > googleMaxHorW) {
          this.$message.error(this.$t('talentpool.exportChromeCheck'))
          return false
        }
        return true
      } else if (agent.indexOf('firefox') > 0) {
        // alert("firefox浏览器")
        if ((width * scale) * (height * scale) > firefoxMaxPixels || width * scale > firefoxMaxHorW || height * scale > firefoxMaxHorW) {
          this.$message.error(this.$t('talentpool.exportFirefoxCheck'))
          return false
        }
        return true
      } else if (agent.indexOf('trident') > 0) {
        // alert("IE浏览器")
        if (width * scale > ieMaxHorW || height * scale > ieMaxHorW) {
          this.$message.error(this.$t('talentpool.exportIeCheck'))
          return false
        }
        return true
      } else {
        return true
      }
    },
    // 下载人员信息
    exportUserInfo () {
      // TODO 需要修改
      let param = { orgId: this.dealershipInfo.orgId, dealerSize: this.dealershipInfo.dealerSize, outLetId: this.outLetId }
      // 如是年度归档
      if (this.queryParams && this.queryParams.carryoverId) {
        param['carryoverId'] = this.queryParams.carryoverId
      }
      if(this.queryParams && this.queryParams.departmentId){
        param['departmentId'] = this.queryParams.departmentId
      }
      this.$request.downloadRm('/talent/positionstandardvalue/exportUserInfo', this.$t('talentpool.userInfoPic'), param)
    },
    // 获取dealership info
    getDealershipInfo (orgId) {
      this.dataLoading = this.$t('talentpool.loadingIn')
      // 清空页面数据
      this.dealershipInfo.bbaNo = ''
      this.dealershipInfo.brandNames = ''
      this.dealershipInfo.dealerSize = ''
      this.dealershipInfo.nameCn = ''
      this.dealershipInfo.nameEn = ''
      this.dealershipInfo.networkTypes = ''
      this.dealershipInfo.nscNo = ''
      this.dealershipInfo.orgId = ''
      this.dealershipInfo.outletList = []
      this.dealershipInfo.regionName = ''
      // 清空下拉选默认是全部
      this.outLetId = ''
      // 清空组织架构树
      this.data = {}
      // 参数
      let param = {}
      if (orgId) {
        param['orgId'] = orgId
      }
      // 如是年度归档
      if (this.queryParams && this.queryParams.carryoverId) {
        param['carryoverId'] = this.queryParams.carryoverId
      }
      this.$request.post(
        '/talent/positionstandardvalue/queryOutLetByDealerShipId', param).then((res) => {
        if (res && res.orgId && res.outletList) {
          this.dealershipInfo = res
          if(this.queryParams && this.queryParams.departmentCnName){
            this.dealershipInfo.nameCn = this.dealershipInfo.nameCn + '-' + this.queryParams.departmentCnName
          }

          // 加载iframe
          this.$nextTick(function () {
            this.initIframe()
          })

          // 默认赋值第一个
          this.outLetId = res.outletList[0].orgId
          // TODO 需要修改
          this.getDepartmentTree(res.orgId, res.dealerSize, res.outletList[0].orgId)
          // let outLetId = res.outletList && res.outletList[0].orgId ? res.outletList[0].orgId : 0
          // this.getDepartmentTree(res.orgId, 'B', outLetId)
        } else {
          this.dataLoading =  this.$t('talentpool.temporarilyNoData')
        }
      }).catch((error) => {
        this.dataLoading = this.$t('talentpool.temporarilyNoData')
        // this.$message.error(error)
      })
    },
    /**
     * 获取dealership的组织树
     * @param orgId
     * @param dealerSize
     * @param outLetId
     * @param url
     */
    getDepartmentTree (orgId, dealerSize, outLetId, date, url) {
      this.data = {}
      this.dataLoading = this.$t('talentpool.loadingIn')
      let params = {
        orgId: orgId,
        dealerSize: dealerSize,
        outLetId: outLetId
      }
      // 如是年度归档
      if (this.queryParams && this.queryParams.carryoverId) {
        params['carryoverId'] = this.queryParams.carryoverId
      }
      // 如果是按照部门查询
      if(this.queryParams && this.queryParams.departmentId){
        params['departmentId'] = this.queryParams.departmentId
      }
      let defaultUrl = '/talent/positionstandardvalue/queryUserInfoByOutLet'
      if (url) {
        defaultUrl = url
        params['date'] = date
      }
      this.$request.post(
        defaultUrl, params
      ).then((res) => {
        this.dataLoading = this.$t('talentpool.temporarilyNoData')
        this.data = res || {}
      }).catch((error) => {
        this.data = {}
        this.dataLoading = this.$t('talentpool.temporarilyNoData')
        this.$message.error(error)
      })
    },
    /**
     * 渲染人员卡片函数
     * @param h 渲染函数
     * @param data 该节点的数据
     */
    nodeRender (h, data) {
      // 卡片的宽度
      let cardMinWidth = '170px'
      // 卡片背景颜色
      let cardBackground = 'rgb(251, 252 , 254)'
      let honorsWorkYears = []
      if (data.honors) {
        honorsWorkYears.push(<span style="padding-right: 4px;">{data.honors}</span>)
      }
      // 右下角宝龄,改为
      // if (data.workYears) {
      //   honorsWorkYears.push(<span>{data.workYears}</span>)
      // }
      // 宝龄
      let workTimeArr = []
      if(data.workYears){
        workTimeArr.push(<span style="font-size:11px;">{'宝龄'+ data.workYears}</span>)
      }else{
        workTimeArr.push(<span style="font-size:11px;">&nbsp;&nbsp;</span>)
      }
      let needMarginTop = true
      let levelArr = []
      if (Array.isArray(data.certificationList) && data.certificationList.length > 0) {
        levelArr = data.certificationList.map((item, index) => {
          return <span key={index} style="display: block;font-size:8px;">
            <span style="padding-right: 4px;">{item.certificationName}</span>
            <span>{item.certificationLevel}</span>
          </span>
        })
        if (data.certificationList.length >= 3) needMarginTop = true
      }
      let header = []
      if (data.isShowHeader && data.headerUrl) {
        // 如果有头像卡片宽度变宽
        cardMinWidth = '220px'
        cardBackground = 'rgb(255, 255 , 255)'
        // "https://www.html.cn/newimg88/2009/05/feiwen8772qqcom_2da5419d.jpg"
        header.push(<div style="display: inline-block;vertical-align: middle;text-align: left;padding-right:8px;vertical-align: middle;">
          <img alt="" src={ data.headerUrl } style="width: 30px;height: 30px;border-radius: 50%;" />
        </div>)
        // header.push(<div style="display: inline-block;vertical-align: middle;text-align: left;padding-right:8px;vertical-align: middle;">
        //   <img alt="" src="https://www.html.cn/newimg88/2009/05/feiwen8772qqcom_2da5419d.jpg" style="width: 30px;height: 30px;border-radius: 50%;" />
        // </div>)
      }
      let partTimeJob = []
      // 添加一级和二级蓝色线条
      // if (!data.isLeaf) {
      if(data.isShowHeader){
        partTimeJob.push(<div style="height: 4px;background-color: #366bb7;border-top-right-radius: 3px;border-top-left-radius: 3px;"></div>)
      }
      // 如果是兼职
      let positionInfo = []
      if (data.partTimeJob) {
        cardBackground = 'rgb(238, 238 , 238)'
        partTimeJob.push(
          <div style="display: inline-block;position: absolute;right: 0;font-size: 12px;background-color: #376ad7;padding: 2px 7px;color: white;">兼职</div>
        )
        positionInfo.push(<div style="font-size:13px;width: 115px">{data.positionCode+'_'+data.positionName}</div>)
      }else{
        positionInfo.push(<span style="font-size:13px">{data.positionCode+'_'+data.positionName}</span>)
      }
      return (
        <div style={{ 'text-align': 'left','width': cardMinWidth,'background': cardBackground}}>
          {partTimeJob}
          <div style={{ 'padding-left': '8px', 'padding-top': needMarginTop ? '6px' : '', 'padding-bottom': needMarginTop ? '6px' : '' }}>
            {header}
            <div style="padding: 4px 0;min-height: 50px;text-align: left;display: inline-block;vertical-align: middle;">
              {positionInfo}
              <span style="display: block;font-weight: bold;line-height: 36px;font-size:16px;">{data.userNameCn}</span>
              {workTimeArr}
            </div>
            <div style="text-align: right;display: inline-block;position: absolute;bottom: 0;right: 0;padding-right: 6px;padding-bottom: 5px;color: #0985e8;">
              <span style="display: block;font-size:8px;">
                {honorsWorkYears}
              </span>
              {levelArr}
            </div>
          </div>
        </div>
      )
    },
    onNodeClick (e, data) {
      console.log(data)
    },
    onExpand (val, status) {
      console.log(val, status)
    },
    buttonRender (h, data) {
      return (
        <div style={{ width: '20px', height: '20px', background: data.expand ? 'red' : 'yellow' }}></div>
      )
    },
    // select切换outLet
    outLetChange (outLetId) {
      // TODO 需要修改
      this.getDepartmentTree(this.dealershipInfo.orgId, this.dealershipInfo.dealerSize, outLetId)
    },
    // 鼠标右击成员列表事件
    rightClickHandler (e, data) {
      if (!this.outLetId || String(this.outLetId) === '0') {
        return false
      }
      if(data.isEdit === '0'){
        this.$message.warning('空岗人员不允许分组!')
        return false
      }
      let params = {
        positionId: data.positionId,
        userId: data.userId,
        orgId: data.orgId,
        outletId: data.outletId,
        // TODO 需要修改
        dealerSize: this.dealershipInfo.dealerSize
      }
      this.$request.post(
        '/talent/group/queryGroupInfo', params
      ).then((res) => {
        if (res.isEdit === 'allow') {
          this.curRightClickId = res.id
          this.curRightClickUserId = data.userId
          this.positionId = data.positionId
          this.groupName = res.name
          this.groupTableData = res.groupmMemberList || []
          this.$refs.contextmenuRef.setPosition(e)
          this.$refs.contextmenuRef.showMenu()
        }else{
          this.$message.error(this.$t('talentpool.userNotAllowGroup'))
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    compare (a, b) {
      // isChecked为true的排在前面
      if (a.isChecked) {
        return -1
      }
      return 0
    },
    // 右键编辑按钮
    updateGroupList () {
      this.contextMenuVisible = false
      this.dialogVisible = true
      this.$nextTick(function () {
        this.toggleSelection()
      })
    },
    // 保存小组
    saveGroup () {
      if (!this.groupName) {
        this.$message.error(this.$t('talentpool.groupNameIsNotEmpty'))
        return false
      }
      if (this.$refs.groupTableRef.selection <= 0) {
        this.$message.error(this.$t('talentpool.noSelectGroupMember'))
      } else {
        this.saveGroupList()
      }
    },
    // 解散小组
    dissolution () {
      let params = {
        id: this.curRightClickId
      }
      this.$request.post(
        '/talent/group/dissolution', params
      ).then((res) => {
        this.dialogVisible = false
        this.$message.success(this.$t('talentpool.operateSuccess'))
        this.getDepartmentTree(this.dealershipInfo.orgId, this.dealershipInfo.dealerSize, this.outLetId)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存小组信息
    saveGroupList () {
      let params = {
        id: this.curRightClickId,
        name: this.groupName,
        positionId: this.positionId,
        groupLeaderUserId: this.curRightClickUserId,
        groupmMemberList: this.$refs.groupTableRef.selection
      }
      this.$request.post(
        '/talent/group/save', params
      ).then((res) => {
        this.dialogVisible = false
        this.$message.success(this.$t('talentpool.saveSuccess'))
        // TODO 需要修改
        this.getDepartmentTree(this.dealershipInfo.orgId, this.dealershipInfo.dealerSize, this.outLetId)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 对小组成员进行排序
    toggleSelection () {
      this.groupTableData = this.groupTableData.sort(this.compare)
      this.groupTableData.forEach(row => {
        if (row.isChecked) {
          this.$refs.groupTableRef.toggleRowSelection(row)
        }
      })
      this.$forceUpdate()
    },
    // 导出excel
    exportExcel () {
      this.$message.success('export success')
    },
    /**
     * 打印导出
     */
    doPrint () {
      this.$nextTick(function () {
        Print(this.$refs['bba_print_ref'], this.doPrintCallback)
      })
    },
    /**
     * 打印导出的回调函数
     * @param bodyS
     * @param bt
     * @param eldS
     * @param dc
     * @param body
     * @param cloneN
     */
    doPrintCallback: function (bodyS, bt, eldS, dc, body, cloneN) {
      eldS.display = ''
      // 还原样式
      bodyS = bt
      eldS = dc
      // 移除节点
      body.removeChild(cloneN)
    },
    initIframe () {
      this.ochartIframeUrl = ''
      if(!this.dealershipInfo.orgId){
        return;
      }
      let dashboardStyle = '&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      // let url = 'https://testjoylearning.bmw.com.cn:5500/#/share/EE7BB5481/infographic/EA7503621'
      //let url = 'https://testjoylearning.bmw.com.cn:5500/#/private/share/EE7BB5481/infographic/EA7503621'
      // let search = '?where=[{"show":true,"datasetId":22,"fieldName":"parent_org_id_11_12","use":"checkbox","kind":"function","op":"in","args":[{"kind":"field","op":"parent_org_id_11_12","dataset":22},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":22}],"field":{"originType":"integer","config":{},"fieldName":"parent_org_id_11_12","basicType":"string","defaultAggrType":"count","hsVersion":4,"oriLabel":"parent_org_id","oriName":"parent_org_id_11","nativeType":"BIGINT","visible":true,"datasetId":22,"label":"parent_org_id","suggestedTypes":["number","string"],"detectedType":"integer","minValue":0,"maxValue":0,"fieldType":"string","dataUniq":["'+this.dealershipInfo.orgId+'"]},"dataset":22}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      //let search = '?where=[{"args":[{"kind":"field","op":"u_16911fc2843df8b5_0_30","dataset":36},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":36}],"op":"in","fieldName":"u_16911fc2843df8b5_0_30","field":{"label":"org_id_1","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_16911fc2843df8b5_0","visible":true,"dataUniq":["'+this.dealershipInfo.orgId+'"],"maxValue":0,"minValue":0,"oriLabel":"parent_org_id","basicType":"string","datasetId":36,"fieldName":"u_16911fc2843df8b5_0_30","fieldType":"string","hsVersion":8,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"use":"checkbox","kind":"function","show":true,"datasetId":36,"dataset":36},{"show":true,"datasetId":37,"fieldName":"u_0b5f1f4480ed5870_0_31","use":"checkbox","kind":"function","op":"in","args":[{"kind":"field","op":"u_0b5f1f4480ed5870_0_31","dataset":37},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":37}],"field":{"originType":"string","config":{"seperator":" ","dialectName":"EngineDialect"},"fieldName":"u_0b5f1f4480ed5870_0_31","basicType":"string","defaultAggrType":"count","hsVersion":10,"oriLabel":"dealer_id","oriName":"u_0b5f1f4480ed5870_0","nativeType":"text","visible":true,"datasetId":37,"label":"org_id_c","suggestedTypes":["number","string"],"detectedType":"number","minValue":0,"maxValue":0,"fieldType":"string","dataUniq":["'+this.dealershipInfo.orgId+'"]},"dataset":37}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      //let search = '?where=[{"args":[{"kind":"field","op":"u_0b5f1f4480ed5870_0_31","dataset":37},{"kind":"constant","op":["orgIdReplace"],"dataset":37}],"op":"in","fieldName":"u_0b5f1f4480ed5870_0_31","field":{"label":"org_id_c","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_0b5f1f4480ed5870_0","visible":true,"dataUniq":["orgIdReplace"],"basicType":"string","datasetId":37,"fieldName":"u_0b5f1f4480ed5870_0_31","fieldType":"string","hsVersion":10,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"use":"checkbox","kind":"function","show":false,"datasetId":37,"dataset":37},{"args":[{"kind":"field","op":"u_16911fc2843df8b5_0_30_36_50","dataset":58},{"kind":"constant","op":["orgIdReplace"],"dataset":58}],"op":"in","fieldName":"u_16911fc2843df8b5_0_30_36_50","field":{"label":"org_id_1","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_16911fc2843df8b5_0_30_36","visible":true,"dataUniq":["orgIdReplace"],"basicType":"string","datasetId":58,"fieldName":"u_16911fc2843df8b5_0_30_36_50","fieldType":"string","hsVersion":1,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"showTag":false,"use":"checkbox","kind":"function","show":false,"datasetId":58,"dataset":58}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      this.ochartIframeUrl = window.SITE_CONFIG['ochartDashboardTwoUrl'].replace(/orgIdReplace/g, this.dealershipInfo.orgId)+dashboardStyle
      console.log(this.ochartIframeUrl)
    },
    initMethod () {
      this.ochartIframeUrl = ''
      if (this.$route.query.orgId) {
        this.getDealershipInfo(this.$route.query.orgId)
      } else {
        this.getDealershipInfo()
      }
    },
    queryWarterMark() {
      this.$request
        .post("/talent/talentpool/queryWarterMarkInfo", {})
        .then((res, total, code, data) => {
          this.warterMarkContent = data.data
        })
        .catch((err) => {
          console.log(err)
        });
    }
  },
  mounted () {
    this.ochartIframeUrl = ''
    let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const queryBoxHeight = this.$refs.queryBox.offsetHeight;
    const a = winHeight - queryBoxHeight;
    this.cardHeight = a
    this.initMethod()
    this.$eventHub.$on('clickCarryoverRecord', (data) => {
      this.initMethod()
    })
    // 获取水印内容
    this.queryWarterMark()
    // 清空水印 内容
    this.clearWaterMark()
  },
  beforeDestroy  () {
    this.$eventHub.$off('clickCarryoverRecord')
  }
}
</script>

<style lang="css" scoped>
  a {
    color: #333;
  }
  .right-menu {
    position: fixed;
    background: #fff;
    border: solid 1px rgba(0, 0, 0, .2);
    border-radius: 3px;
    z-index: 999;
    display: none;
  }
  .right-menu a {
    width: 75px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    display: block;
    color: #1a1a1a;
    text-decoration: none;
  }
  .right-menu a:hover {
    background: #F5F5F5;
    /*color: #fff;*/
  }
</style>
